// extracted by mini-css-extract-plugin
module.exports = {"Root":"styles_Root__CUWGt"};